import Cookies from 'js-cookie';

import { ACCESS_TOKEN_KEY, DEFAULT_ACCESS_TOKEN_EXPIRES_IN } from '../constants';

type SetAccessTokenParams = {
  expiresIn?: number;
  token: string;
};

export function setAccessToken({ expiresIn, token }: SetAccessTokenParams) {
  if (!token) {
    return;
  }
  try {
    const expiredTime = new Date(
      new Date().setSeconds(expiresIn ?? DEFAULT_ACCESS_TOKEN_EXPIRES_IN),
    );
    Cookies.set(ACCESS_TOKEN_KEY, token, {
      expires: expiredTime,
      path: '/',
      secure: true,
    });
  } catch (e) {
    window?.newrelic?.noticeError(e as Error, { message: 'setAccessToken' });
  }
}
